if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);

        // Give immediate feedback on product cards and product pages while
        // Shopify confirms the add. Keep quick-add modals open so validation
        // errors stay visible inside the modal.
        if (!this.closest('quick-add-modal') && typeof this.cart.open === 'function') {
          this.cart.setAttribute('data-cart-pending', 'add');
          this.cart.setAttribute('aria-busy', 'true');
          this.cart.open(document.activeElement, { refresh: false });
        }
      }
      config.body = formData;

      if (typeof this.cart?.noteCartMutation === 'function') this.cart.noteCartMutation();
      const tracksCartOperation = typeof this.cart?.beginCartOperation === 'function';
      if (tracksCartOperation) this.cart.beginCartOperation();

      // Shopify returns structured sold-out and validation details with 4xx
      // responses, so parse the body and let the existing response.status path
      // show the customer-facing message.
      const addToCart = () => fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json());
      const addRequest = typeof this.cart?.enqueueCartOperation === 'function'
        ? this.cart.enqueueCartOperation(addToCart)
        : addToCart();

      addRequest
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;

          // GA4 Enhanced Ecommerce: add_to_cart
          if (typeof gtag === 'function' && response.items && response.items.length > 0) {
            var item = response.items[0];
            gtag('event', 'add_to_cart', {
              currency: response.currency,
              value: item.final_line_price / 100,
              items: [{
                item_id: item.product_id,
                item_name: item.product_title,
                item_variant: item.variant_title,
                price: item.final_price / 100,
                quantity: item.quantity
              }]
            });
          }
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCartWithCurrentDiscounts(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            return this.renderCartWithCurrentDiscounts(response);
          }
        })
        .catch(() => {
          // Error handled silently
        })
        .finally(() => {
          if (tracksCartOperation) {
            this.cart.endCartOperation();
          } else if (this.cart) {
            this.cart.removeAttribute('aria-busy');
            this.cart.removeAttribute('data-cart-pending');
          }
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    renderCartWithCurrentDiscounts(fallbackResponse) {
      const shouldOpenDrawer = !this.cart.classList.contains('active');
      this.cart.classList.remove('is-empty');
      this.cart.renderContents(fallbackResponse, { openDrawer: shouldOpenDrawer });
      if (typeof this.cart.markCartFresh === 'function') this.cart.markCartFresh();

      return Promise.resolve();
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
